import { itemOrderReceiving, itemOrderReturn } from './itemOrderReceiving';
import { Outward } from './outwards';

export interface Orders {
  orderId: string;
  orderDateTime: string;
  username: string;
  customerId: string;
  departmentId: string;
  templateId: string;
  isActive: boolean;
  isReceiving: boolean;
  isDelivery: boolean;
  isReturn: boolean;
  itemOrderDelivery: Outward[];
  itemOrderReceiving: itemOrderReceiving[];
  itemReturnOrder: itemOrderReturn[];
}

export const OrderInitialState = {
  orderId: '',
  orderDateTime: '',
  username: '',
  customerId: '',
  departmentId: '',
  templateId: '',
  isActive: true,
  departmentName: '',
  isReceiving: false,
  isDelivery: false,
  isReturn: false,
  itemOrderDelivery: [],
  itemOrderReceiving: [],
  itemReturnOrder: [],
};
